import { GAME_WIDTH, GAME_HEIGHT } from '../config.js';
import { audioManager } from '../audio/AudioManager.js';
import { iconText } from './iconText.js';

// A burst of confetti and a banner, for the moments that deserve one (passing the driving
// exam). Resolves when the banner has faded; the caller shows whatever comes next.
//
//   await celebrate(scene, { title: 'Zdany egzamin! 🎉', subtitle: 'Masz prawo jazdy' });

const COLOURS = [0xff5c8a, 0xffc94d, 0x4dd0e1, 0x7bd67b, 0xb388ff, 0xff8a65];
const DURATION_MS = 2600;

function confettiTexture(scene) {
  if (scene.textures.exists('confetti_piece')) return;
  const g = scene.make.graphics({ x: 0, y: 0, add: false });
  g.fillStyle(0xffffff).fillRect(0, 0, 10, 14);
  g.generateTexture('confetti_piece', 10, 14);
  g.destroy();
}

export function celebrate(scene, { title, subtitle = '' } = {}) {
  return new Promise((resolve) => {
    const cam = scene.cameras.main;
    const cx = cam.scrollX + GAME_WIDTH / 2, cy = cam.scrollY + GAME_HEIGHT / 2;
    confettiTexture(scene);
    const layer = scene.add.container(0, 0).setDepth(2500);
    const emitter = scene.add.particles(0, 0, 'confetti_piece', {
      x: { min: cam.scrollX, max: cam.scrollX + GAME_WIDTH },
      y: cam.scrollY - 20,
      lifespan: 2600,
      speedY: { min: 160, max: 320 },
      speedX: { min: -60, max: 60 },
      gravityY: 120,
      rotate: { start: 0, end: 720 },
      scale: { min: 0.8, max: 1.4 },
      tint: COLOURS,
      quantity: 6,
      frequency: 40,
      duration: 1400,
    });
    layer.add(emitter);
    const banner = iconText(scene, cx, cy - 40, title, {
      fontFamily: 'system-ui', fontSize: '56px', color: '#ffffff', fontStyle: 'bold',
      stroke: '#7b2d8b', strokeThickness: 10, align: 'center',
    }).setOrigin(0.5).setScale(0.2);
    const sub = iconText(scene, cx, cy + 32, subtitle, {
      fontFamily: 'system-ui', fontSize: '28px', color: '#fff6b0', fontStyle: 'bold',
      stroke: '#7b2d8b', strokeThickness: 6, align: 'center',
    }).setOrigin(0.5).setAlpha(0);
    layer.add([banner, sub]);
    audioManager.playSfx('game_start');
    scene.tweens.add({ targets: banner, scale: 1, duration: 500, ease: 'Back.easeOut' });
    scene.tweens.add({ targets: sub, alpha: 1, duration: 400, delay: 350 });
    scene.time.delayedCall(DURATION_MS, () => {
      scene.tweens.add({
        targets: [banner, sub], alpha: 0, duration: 400,
        onComplete: () => { layer.destroy(); resolve(); },
      });
    });
  });
}
